/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespSimilarItem_viewer = {
    readonly isSeoQuicklookEnabled: boolean | null;
    readonly isFavoritesEnabled: boolean | null;
    readonly " $refType": "PdpRespSimilarItem_viewer";
};
export type PdpRespSimilarItem_viewer$data = PdpRespSimilarItem_viewer;
export type PdpRespSimilarItem_viewer$key = {
    readonly " $data"?: PdpRespSimilarItem_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSimilarItem_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSimilarItem_viewer",
  "selections": [
    {
      "alias": "isSeoQuicklookEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "SEO_QUICKLOOK"
        }
      ],
      "kind": "ScalarField",
      "name": "isEnabledByLocale",
      "storageKey": "isEnabledByLocale(featureName:\"SEO_QUICKLOOK\")"
    },
    {
      "alias": "isFavoritesEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "FAVORITES"
        }
      ],
      "kind": "ScalarField",
      "name": "isEnabledByLocale",
      "storageKey": "isEnabledByLocale(featureName:\"FAVORITES\")"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
(node as any).hash = '7c25128694f1321b4000ed8c8b6a13c3';
export default node;
